// Entrypoint bundled by Vite (see config/vite.json → sourceCodeDir).
console.log('Vite ⚡️ Ruby + Svelte 5 + Tailwind CSS is running')

// Global CSS (Tailwind lives here)
import './application.css'

// --- Stimulus ---
import { Application } from '@hotwired/stimulus'
const stimulusApp = Application.start()
stimulusApp.debug = false
window.Stimulus = stimulusApp

import HelloController from '../controllers/hello_controller.js'
stimulusApp.register('hello', HelloController)

// --- Svelte component mounting ---
import { mountSvelteComponents } from '../mount.js'
mountSvelteComponents()
